import { render, staticRenderFns } from "./sign-item.vue?vue&type=template&id=28b40cb3"
import script from "./sign-item.vue?vue&type=script&lang=js"
export * from "./sign-item.vue?vue&type=script&lang=js"
import style0 from "./sign-item.vue?vue&type=style&index=0&id=28b40cb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports